import type { SessionUser } from "@livcg/nodecg-react";
import { Badge, Button } from "../ui/index.js";
import { ThemeToggle } from "./ThemeToggle.js";

type Props = {
  user: SessionUser | null;
  onLogout: () => void | Promise<void>;
};

/** Signed-in operator cluster for the topbar — username, a role badge, a theme
 *  toggle and a sign-out button, fronted by a divider. Returns null when signed
 *  out (`if (!user) return null`), so the theme toggle shows in Match Day and
 *  Admin but never on the login screen. */
export function UserMenu({ user, onLogout }: Props) {
  if (!user) return null;
  return (
    <>
      <div className="h-6 w-px bg-divider" />
      <div className="flex items-center gap-2">
        <span className="text-[13px] font-medium text-ink">{user.username}</span>
        <Badge tone={user.role === "admin" ? "accent" : "neutral"}>{user.role}</Badge>
      </div>
      <ThemeToggle />
      <Button size="sm" variant="ghost" onClick={() => void onLogout()}>
        Chiqish
      </Button>
    </>
  );
}
